import { usePurchaseDownloadXml } from '@/core/domain/purchase/Purchase.hooks';
import { useReportGenerate } from '@/hooks';
import { Button, Col } from 'antd';

interface Props {
  purchaseId?: number;
  purchaseCode?: number;
  hasXml: boolean;
}

export default function PurchaseDownloadXml(props: Props) {
  const downloadXml = usePurchaseDownloadXml();

  const report = useReportGenerate();

  if (!props.hasXml) return null;

  return (
    <Col>
      <Button
        disabled={!props.purchaseId || !props.hasXml}
        loading={downloadXml.isLoading}
        onClick={async () => {
          const result = await downloadXml.mutateAsync(
            props.purchaseId as number,
          );
          report.downloadFile({
            result,
            fileName: `compra-${props.purchaseCode}-${Number(new Date())}`,
            type: 'text/xml',
          });
        }}
      >
        Baixar XML
      </Button>
    </Col>
  );
}
